import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function FlightBookingApi() {
  const faqs = [
    {
      question: "What is Mokshiq Flight & Travel Booking API?",
      answer: "Mokshiq Travel API (by Rakle Service Private Limited) connects your portal to GDS and LCC airline engines for real-time flight search, seat selection, booking, and automated ticket issuance."
    },
    {
      question: "Which airlines are supported?",
      answer: "We support Indigo, Air India, Akasa Air, SpiceJet, Vistara, and major international carriers with competitive B2B net fares."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-plane me-2"></i>Travel API Suite
            </span>
            <h1 className="page_title text-white mb-3">Flight &amp; Travel Booking API</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              Instant flight search, seat mapping, and PNR generation powered by <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Travel APIs</a></li>
              <li className="active"><a href="#!">Flight Booking API</a></li>
            </ul>
          </div>
        </section>

        <section className="section_space bg-white">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-plane-departure text-primary fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Domestic Flights</h3>
                  <p className="text-muted small">Real-time seat availability and instant confirmation across all Indian domestic airlines.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-earth-americas text-success fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">International Routes</h3>
                  <p className="text-muted small">Direct GDS integration for worldwide flight itineraries with multi-currency payment support.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-receipt text-warning fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Automated Cancellation &amp; Refund</h3>
                  <p className="text-muted small">Instant PNR cancellation and automated refund calculation via API webhooks.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ faqList={faqs} title="Flight Booking API FAQs" subtitle="Frequently asked questions about travel and flight API integration." />
      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default FlightBookingApi;
